import { useCallback } from 'react';

export const useStopVideos = () => {
  const stopVideos = useCallback(() => {
    const iframes = document.querySelectorAll('iframe.vitrine-video');

    iframes.forEach(iframe => {
      const src = iframe.getAttribute('src');

      iframe.setAttribute('src', '');

      iframe.setAttribute('src', String(src));
    });
  }, []);

  return { stopVideos };
};
